// *******************************************************************************
// Workshop Form Validation
// *******************************************************************************

document.addEventListener('DOMContentLoaded', () => {
  const workshopFormModule = document.querySelector('.workshop-form');
  const workshopForm = document.getElementById('workshop-form__form');
  const loadingHtml = document.querySelector('.loading');
  if (workshopForm) {
    const recaptchaKey = document.querySelector('.recaptcha-button-box').getAttribute('data-sitekey');
    const fv = FormValidation.formValidation(workshopForm, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {
        'workshops': {
          validators: {
            choice: {
              min: 3,
            },
          },
        },
      },
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.input-field,.checkbox-group,.radio-button-group,.dropdown'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.input-field,.checkbox-group,.radio-button-group,.dropdown');
        if (value === '') {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': true,
          });
        } else {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': false,
          });
        }

        if (!e.valid) {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': true,
          });
        } else {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': false,
          });
        }
      })
      .on('core.form.valid', () => {
        loadingHtml.classList.add('is-active');
        grecaptcha.ready(() => {
          grecaptcha.execute(recaptchaKey, { action: 'saveWorkshopData' }).then((token) => {
            // Ajax check if valid
            const formData = {};
            const formDataInput = new FormData();
            workshopForm.querySelectorAll('input, textarea, .sort-workshops__item').forEach((input) => {
              if (input.type === 'text' || input.type === 'textarea' || input.type === 'email' || input.type === 'date') {
                formData[input.name] = input.value.trim();
              } else if (input.type === 'radio') {
                if (input.checked) {
                  formData[input.name] = input.value.trim();
                }
              } else if (input.type === 'checkbox' && input.checked) {
                if (formData[input.name]) {
                  formData[input.name] += `, ${  input.value.trim()}`;
                } else {
                  formData[input.name] = input.value.trim();
                }
              } else if (input.innerHTML) {
                if (formData.workshops_order) {
                  formData.workshops_order += `, ${  input.innerHTML.trim()}`;
                } else {
                  formData.workshops_order = input.innerHTML.trim();
                }
              }
            });
            formDataInput.append('action', document.querySelector('#workshop-form__form_action').value);
            formDataInput.append('nonce', document.querySelector('#workshop-form__form_nonce').value);
            formDataInput.append('token', token);
            formDataInput.append('id', localData.id);
            formDataInput.append('lang', localData.lang);
            formDataInput.append('inputs', JSON.stringify(formData));
            axios
              .post(localData.siteURL, formDataInput, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then((response) => {
                if (response.status === 200) {
                  workshopFormModule.classList.add('show-thankyou');
                }
                workshopFormModule.scrollIntoView({ behavior: 'smooth', block: 'center' });
                loadingHtml.classList.remove('is-active');
              })
              .catch((error) => {
                workshopFormModule.classList.add('show-thankyou');
                workshopFormModule.scrollIntoView({ behavior: 'smooth', block: 'center' });
                loadingHtml.classList.remove('is-active');
                workshopFormModule.querySelector('.workshop-form__thankyou .workshop-form__form-title').innerHTML = '';
                workshopFormModule.querySelector('.workshop-form__thankyou-text').innerHTML = `${error.response.data.data.msg}`;
              });
          });
        });
      });

    const submitBtn = workshopForm.querySelector('.workshop-form__form-submit .btn');
    submitBtn.addEventListener('click', () => {
      setTimeout(() => {
        const firstError = workshopForm.querySelector('.is-validation-failed');
        if (firstError) {
          const firstErrorPos = firstError.offsetTop - 88;
          window.scrollTo(0, firstErrorPos);
        }
      }, 300);
    });

    // **************************************************

    const alergyYes = document.querySelector('#alergy-yes');
    const alergyNo = document.querySelector('#alergy-no');
    if (alergyYes || alergyNo) {
      alergyYes.addEventListener('click', () => {
        if (alergyYes.checked) {
          alergyYes.closest('.workshop-form__radio-group').classList.add('is-open');
        }
        if (alergyNo.checked) {
          alergyNo.closest('.workshop-form__radio-group').classList.remove('is-open');
        }
      });
      alergyNo.addEventListener('click', () => {
        if (alergyYes.checked) {
          alergyYes.closest('.workshop-form__radio-group').classList.add('is-open');
        }
        if (alergyNo.checked) {
          alergyNo.closest('.workshop-form__radio-group').classList.remove('is-open');
        }
      });
    }

// **************************************************

    const workshopSort = document.querySelector('.sort-workshops__items');
    if (workshopSort) {
      // eslint-disable-next-line no-new
      new Sortable(workshopSort, {
        handle: '.sort-workshops__item',
        animation: 200,
        delay: 0,
        delayOnTouchOnly: true,
        ghostClass: "sortable-ghost",
      });
    }

// **************************************************

    const pickWorkshops = document.querySelector('.pick-workshops');
    const sortDiv = document.querySelector('.pick-workshops__sort');
    const nums = document.querySelector('.sort-workshops__nums');

    if (pickWorkshops) {
      const checkboxes = pickWorkshops.querySelectorAll('.checkbox');

      checkboxes.forEach((checkbox) => {
        const input = checkbox.querySelector('input');
        const inputId = input.id;
        const checkboxText = checkbox.querySelector('.checkbox__text').innerHTML;
        const defaultItem = workshopSort.querySelector('.sort-workshops__item');
        const clone = defaultItem.cloneNode(true);
        const defaultNum = nums.querySelector('.sort-workshops__num');
        const numClone = defaultNum.cloneNode(true);

        input.addEventListener('change', (ev) => {
          sortDiv.classList.add('is-active');

          if (ev.currentTarget.checked) {
            workshopSort.append(clone);
            clone.innerHTML = checkboxText;
            slideDown(clone, 300, 'block');
            clone.classList.add(inputId);
            nums.append(numClone);
            slideDown(numClone, 300, 'block');
          } else {
            slideUp(clone, 300, 'none');
            slideUp(numClone, 300, 'none');
            setTimeout(() => {
              clone.remove();
              numClone.remove();
            }, 300);
          }
        });
      });
    }
  }
});

